import React, { Fragment } from 'react'
import Header from '../components/layouts/Header'
import Footer from '../components/layouts/Footer'
import DeveloperType from '../features/registrationstep/DeveloperType'
import { useSelector } from 'react-redux'
import SkillType from '../features/registrationstep/SkillType'
import Developer from '../features/registrationstep/Developer'
import SimplifySection from '../features/common/SimplifySection'
import { CodingBackground } from '../constants/ImagePaths'
import useDocumentTitle from '../hooks/useDocumentTitle';
import useCanonical from '../hooks/useCanonical';
import { Helmet } from 'react-helmet';
import PreviouslyRockedAt from '../features/common/PreviouslyRockedAt'
import { getStructuredDataBaseUrl, getStructuredDataLogoUrl } from '../utils/canonical'


const StartHiring = () => {
    useDocumentTitle("Start Hiring Vetted Developers in 48 Hours");
    const canonicalTag = useCanonical('/start-hiring');

    const { hire_registration: { step } } = useSelector(state => state.common);
    const backgroundStyle = {
        backgroundImage: `url(${CodingBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    }

    return (
        <Fragment>
            <Helmet>
                <title>Hire Top Developers | Dev-Hire</title>
                <meta name="description" content="Start hiring top vetted remote developers today with Dev Hire. Complete our simple form to get matched in 48 hours. Enjoy flexible monthly contracts, no recruitment fees, guaranteed quality, and seamless team scaling with elite software engineers." />
                <script type="application/ld+json">
                    {`{
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        "name": "Dev-Hire",
                        "url": "${getStructuredDataBaseUrl()}",
                        "logo": "${getStructuredDataLogoUrl()}",
                        "sameAs": [
                            "https://www.linkedin.com/company/acveti",
                            "https://www.instagram.com/devhire_"
                        ],
                        "description": "Dev-Hire helps businesses hire top 3% vetted developers across React, Python, AWS, and more — with transparent pricing and fast onboarding.",
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "telephone": "+1-9176952300",
                            "contactType": "customer service",
                            "areaServed": "IN, US, UK, AE",
                            "availableLanguage": ["English"]
                        }
                    }`}
                </script>
                <script type="application/ld+json">
                    {`{
                        "@context": "https://schema.org",
                        "@type": "WebSite",
                        "name": "Dev-Hire",
                        "url": "${getStructuredDataBaseUrl()}",
                        "potentialAction": {
                            "@type": "SearchAction",
                            "target": "${getStructuredDataBaseUrl()}/search?query={search_term_string}",
                            "query-input": "required name=search_term_string"
                        }
                    }`}
                </script>
            </Helmet>
            {canonicalTag}
            <Header />
            <main className="" style={backgroundStyle}>
                <section className="--layout-padding max-width">
                    <div className="container">
                        {step === 1 && <DeveloperType />}
                        {step === 2 && <SkillType />}
                        {step === 3 && <Developer />}
                    </div>
                </section>
                {[1, 2].includes(step) && <div className="ourTalant">
                    <PreviouslyRockedAt />
                </div>}
                {step === 3 && <SimplifySection />}
            </main>
            <Footer />
        </Fragment>
    )
}

export default StartHiring